import { render } from "./WebinarsSwiper.vue?vue&type=template&id=d85e3a4a"
import script from "./WebinarsSwiper.vue?vue&type=script&lang=js"
export * from "./WebinarsSwiper.vue?vue&type=script&lang=js"

import "./WebinarsSwiper.vue?vue&type=style&index=0&id=d85e3a4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__